export default __webpack_public_path__ + "static/media/icon_search.92874e6c.svg";